import { basicListAddEditDltInitialState } from '../../../../../stateManagement/reduxUtil';
import { commonTypes } from '../../../../common/redux/actions/commonActions';
import { acInquiryActionTypes } from '../actions/actionTypes';

const resetServerValue = (state, action) => ({
  ...state,
  serverRequestError: action.data && action.data.serverRequestError,
});

const AccountingInquiry = (state = { ...basicListAddEditDltInitialState }, action = null) => {
  switch (action.type) {
    // Configure Page Details
    case acInquiryActionTypes.SET_ACINQ_DETAILS_RESPONSE:
      return {
        ...state,
        subModuledetails: action.data,
      };
    case acInquiryActionTypes.RESET_SERVER_VALUE:
      return resetServerValue(state, action);
    case commonTypes.RESETSTORE:
      return basicListAddEditDltInitialState;
    default:
      return state;
  }
};

export default AccountingInquiry;
